import React, { Component } from 'react';
import { Group } from 'react-konva';
import { connect } from 'react-redux';
import { ICard, ICardsRenderInfo, RecordState } from '../../redux/types';
import { hintMoveToFn } from '../types';
import { KonvaEventObject, Vector2d } from 'konva/types/types';
import { getGameX } from '../../utils';
import global from '../../global';
import Shadow, { ShadowProps } from './Shadow';
import { Orientation } from '../../utils/detectOrientation';

type IProps = {
  children?: object | null;
  card: ICard;
  cardParameters: ICardsRenderInfo;
  draggable: boolean;
  shadowProps: ShadowProps;
  y: number;
  size: number;
  onDragStart(event: KonvaEventObject<any>): void;
  onDragEnd(event: KonvaEventObject<any>): void;
  onDblClick: (node: any) => void;
  orientation: Orientation | void;
  moveTo?: hintMoveToFn;
};

class DraggableGroup extends Component<IProps> {
  node: any = null;

  render() {
    const {
      children,
      draggable,
      onDragEnd,
      onDragStart,
      cardParameters,
      card,
      moveTo,
      onDblClick,
      shadowProps,
      y,
      orientation,
      size,
    } = this.props;

    const { width } = cardParameters;

    const gameX = getGameX(size);
    const maxXPoint = global.size(orientation) - width - gameX;

    return (
      <Group
        ref={node => (this.node = node)}
        y={y}
        onClick={() => onDblClick(this.node)}
        onDblTap={() => onDblClick(this.node)}
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
        dragBoundFunc={(pos: Vector2d) => {
          let x = pos.x;
          if (x < gameX) x = gameX;
          else if (x > maxXPoint) x = maxXPoint;
          const y = pos.y > gameX ? pos.y : gameX;
          return {
            x,
            y,
          };
        }}
        draggable={draggable}
        name={card.name}
        moveTo={moveTo}
      >
        <Shadow {...shadowProps} />
        {children}
      </Group>
    );
  }
}

function mapStateToProps(state: RecordState) {
  return {
    cardParameters: state.get('cardsRenderInfo'),
    orientation: state.get('orientation'),
    size: state.get('size'),
  };
}

export default connect(mapStateToProps)(DraggableGroup);
